import { Link } from "react-router-dom";
import "./style.css";

const Footer = () => {
  return (
    <div className="footer">
      <div className="container footer-container">
        <div className="col-lg-4 col-md-4 footer-right">
          <img src={require("../../assets/images/logo.png")} />
          <p>وبسلا، همراه شما در مسیر سلامتی</p>
          <div style={{ height: 100, width: 100 }}>
            <a
              referrerpolicy="origin"
              target="_blank"
              href="https://trustseal.enamad.ir/?id=464486&Code=opNfYiORyELXH91kxdXVd7yPhE8a7OVj"
            >
              <img
                referrerpolicy="origin"
                src="https://trustseal.enamad.ir/logo.aspx?id=464486&Code=opNfYiORyELXH91kxdXVd7yPhE8a7OVj"
                alt=""
                style={{ cursor: "pointer" }}
                Code="opNfYiORyELXH91kxdXVd7yPhE8a7OVj"
              />
            </a>
          </div>
        </div>
        <div className="divider"></div>
        <div className="col-lg-4 col-md-4 footer-center">
          <h5>دسترسی سریع</h5>
          <Link to={"/"}>صفحه اصلی</Link>
          <Link to={"/doctors"}>پزشکان</Link>
          <Link to={"/rules"}>قوانین و مقررات</Link>
          <Link to={"/aboutus"}>درباره ما</Link>
        </div>
        <div className="divider"></div>
        <div className="col-lg-4 col-md-4 footer-left">
          <h5>ارتباط با ما</h5>
          <div className="row footer-left-content">
            <div className="col-lg-4 col-6 footer-left-vals">
              <div>ایمیل:</div>
              <div>شماره تماس:</div>
              <div>آدرس:</div>
            </div>

            <div className="col-lg-8 col-6  footer-left-vals">
              <div className="value">info@websla.ir</div>
              <div className="value">051-91099535 </div>
              <div className="value">
                مشهد، بلوار جانباز،جنب پروما،مجتمع نیکا،واحد 602
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
